import { createAsyncThunk } from '@reduxjs/toolkit';

import { instance } from '../../shared/services/app/instance';

import * as toasty from '../../shared/toastify/toastify';

const fetchAllEnums = createAsyncThunk(
  'allEnums/fetch',
  async ({ type, page, limit }, thunkApi) => {
    try {
      const response = await instance.get(`/enums/${type}`, {
        params: {
          page,
          limit,
        },
      });

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const fetchOneEnum = createAsyncThunk(
  'oneEnum/fetch',
  async ({ id, type }, thunkApi) => {
    try {
      const response = await instance.get(`/enums/${type}/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const addNewEnum = createAsyncThunk(
  'addNewEnum/post',
  async ({ dataBody }, thunkApi) => {
    const { type, name, description, weight, active, category } = dataBody;

    try {
      const requestBody = { name };

      // Add additional fields for skills
      if (type === 'skills') {
        if (description !== undefined) requestBody.description = description;
        if (weight !== undefined) requestBody.weight = weight;
        if (active !== undefined) requestBody.active = active;
        if (category !== undefined) requestBody.category = category;
      }

      const response = await instance.post(`/enums/${type}`, requestBody);
      toasty.toastSuccess('Creating successfully');
      return response.data.data;
    } catch (error) {
      toasty.toastError(error.response.data.message.toLowerCase());
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const updateEnum = createAsyncThunk(
  'updatePartner/put',
  async ({ dataBody }, thunkApi) => {
    const { id, type, name, description, weight, active, category } = dataBody;

    try {
      const requestBody = { name };

      // Add additional fields for skills
      if (type === 'skills') {
        if (description !== undefined) requestBody.description = description;
        if (weight !== undefined) requestBody.weight = weight;
        if (active !== undefined) requestBody.active = active;
        if (category !== undefined) requestBody.category = category;
      }

      const response = await instance.put(`/enums/${type}/${id}`, requestBody);
      toasty.toastSuccess('Update successfully');
      return response.data.data;
    } catch (error) {
      toasty.toastError(error.response.data.message);
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const deleteEnum = createAsyncThunk(
  'deleteEnum/delete',
  async ({ id, type }, thunkApi) => {
    try {
      const response = await instance.delete(`/enums/${type}/${id}`);
      toasty.toastSuccess('Deleting successfully');
      return response.data.data;
    } catch (error) {
      toasty.toastError(error.response.data.message);
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const enumsOperations = {
  fetchAllEnums,
  fetchOneEnum,
  addNewEnum,
  deleteEnum,
  updateEnum,
};

export default enumsOperations;
